import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Box, Paper, Stack } from '@facet-wealth/design';
import Text from 'Components/ComponentLibrary/Atoms/Text';

const IMAGE_DIMENSION = 24;
const IMAGE_SPACING = 8;

const useStyles = buildUseStyles('AccountCard', (theme) => ({
  root: {
    padding: theme.spacing(1, 2),
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: IMAGE_DIMENSION + (2 * IMAGE_SPACING),
    width: IMAGE_DIMENSION,
    flexShrink: 0,
  },
  image: {
    maxWidth: IMAGE_DIMENSION,
    maxHeight: IMAGE_DIMENSION,
    width: '100%',
  },
}));

export default function AccountCard({
  title,
  subtitle,
  image,
}) {
  const classes = useStyles();

  return <>
    <Paper width={'100%'}>
      <div className={classes.root}>
        <Stack spacing={2} alignItems="flex-start" justifyContent="flex-start">
          {image && <div className={classes.imageContainer}><img className={classes.image} src={image} alt={'account'} /></div>}
          <Box overflow={'hidden'}>
            <Text variant={'h4'} weight={'bold'} align={'left'} color={'textPrimary'} noWrap value={title} />
            <Text align={'left'} color={'textSecondary'} value={subtitle} noWrap />
          </Box>
        </Stack>
      </div>
    </Paper>
  </>;
}
